import React from 'react';
import PropTypes from 'prop-types';
import { Script } from 'gatsby';

const ElfSightEmbed = ({ elfsightId, className }) => (
	<div
		className={`block-elfsight ${className || ''}`}
		data-testid='elfsight'
	>
		<Script
			src='https://static.elfsight.com/platform/platform.js'
			data-use-service-core
		/>

		<div
			className={`elfsight-app-${elfsightId} [&>div>div]:!max-w-full`}
			data-silktide='ignore'
			data-testid='elfsight-embed'
			data-elfsight-app-lazy
		/>
	</div>
);

ElfSightEmbed.propTypes = {
	elfsightId: PropTypes.string.isRequired,
	className: PropTypes.string,
};

export default ElfSightEmbed;
